import { render, staticRenderFns } from "./MyCards.vue?vue&type=template&id=ec80d6c0&scoped=true"
import script from "./MyCards.vue?vue&type=script&lang=js"
export * from "./MyCards.vue?vue&type=script&lang=js"
import style0 from "./MyCards.vue?vue&type=style&index=0&id=ec80d6c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec80d6c0",
  null
  
)

export default component.exports